import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { ITextNav } from './text.nav.interface';

@Component({
    selector: 'mlp-ng-text-nav',
    templateUrl: './text.nav.component.html',
    styleUrls: ['./text.nav.component.scss'],
    // tslint:disable-next-line:use-view-encapsulation
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextNavSharedComponent {
    @Input() config: ITextNav;
}
